import {
    TECSUBMIT_IMAGES_SUCCESS,
    TECSUBMIT_IMAGES_FAIL
  } from "../action.types";
  import initialValue from "../initial.state";
  
  export default function (state = initialValue.filesTecSubmit, action) {
    switch (action.type) {
      case TECSUBMIT_IMAGES_SUCCESS:
        return action.payload.values;
      case TECSUBMIT_IMAGES_FAIL:
        return state;
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/redux/serviceOrder/filesServiceOrder.reducer.js